if (!customElements.get('customer-login')) {
    class CustomerLogin extends HTMLElement {
        constructor() {
            super();
            this.resetPassword = this.querySelector('#RecoverPasswordForm');
            this.CustomerLoginForm = this.querySelector('#CustomerLoginForm');
            this.addEventListener('click', this.eventHandle.bind(this));
        }
        eventHandle(event) {
            if(event.target.closest('#RecoverPassword')) {
                this.resetPassword.classList.remove('hide');
                this.CustomerLoginForm.classList.add('hide');
            }
            if(event.target.closest('#HideRecoverPasswordLink')) {
                this.resetPassword.classList.add('hide');
                this.CustomerLoginForm.classList.remove('hide');
            }
            if(event.target.closest('.tabs-item')) {
                if(event.target.closest('.tabs-item').dataset.tabIndex === "1") {
                    event.target.closest('.tabs').querySelector('.tabs-item[data-tab-index="1"]').classList.add('active');
                    event.target.closest('.tabs').querySelector('.tabs-item[data-tab-index="2"]').classList.remove('active');
                    event.target.closest('.tabs').querySelector('.tabs-content[data-tab-index="1"]').classList.add('active');
                    event.target.closest('.tabs').querySelector('.tabs-content[data-tab-index="2"]').classList.remove('active');
                }
                if(event.target.closest('.tabs-item').dataset.tabIndex === "2") {
                    event.target.closest('.tabs').querySelector('.tabs-item[data-tab-index="1"]').classList.remove('active');
                    event.target.closest('.tabs').querySelector('.tabs-item[data-tab-index="2"]').classList.add('active');
                    event.target.closest('.tabs').querySelector('.tabs-content[data-tab-index="1"]').classList.remove('active');
                    event.target.closest('.tabs').querySelector('.tabs-content[data-tab-index="2"]').classList.add('active');
                }
            }
        }
    }
   customElements.define('customer-login', CustomerLogin);
}